// Pickup

const actionTypes = {
    reset: 'reset',
};
const mutationTypes = {
    SET_FIELDS_CUSTOMER: 'SET_FIELDS_CUSTOMER',
    SET_FIELDS_EXTERNAL_REF: 'SET_FIELDS_EXTERNAL_REF',
};

export default {
    namespaced: true,
    state: {
        fields: {
            /** @type { Object } */
            customer: {
                customerId: null,
                name: '',
            },
            externalRef: null,
        },
    },
    getters: {
    },
    actions: {
        async [ actionTypes.reset ]( context ) {
            context.commit( mutationTypes.SET_FIELDS_CUSTOMER, { customer: { customerId: null, name: '' } } );
            context.commit( mutationTypes.SET_FIELDS_EXTERNAL_REF, { externalRef: '' } );
        },
    },
    mutations: {
        [ mutationTypes.SET_FIELDS_CUSTOMER ]( state, { customer } ) {
            state.fields.customer = customer;
        },
        [ mutationTypes.SET_FIELDS_EXTERNAL_REF ]( state, { externalRef } ) {
            state.fields.externalRef = externalRef;
        },
    },
};
